import { CAPACITY_DOMAINS } from './domains';

const createTemplateForDomain = (id: string, name: string) => ({
  id,
  name,
  goal: 'Purpose, Mission & Values',
  content: {
    title: `Capacity Building Plan - ${name}`,
    fields: [
      {
        type: 'text',
        label: 'Start Date',
        key: 'startDate'
      },
      {
        type: 'text',
        label: 'End Date',
        key: 'endDate'
      }
    ],
    instructions: `Use this template to create a capacity building plan focused on ${name.toLowerCase()}.`,
    goals: [
      {
        title: 'Goal',
        fields: [
          {
            type: 'textarea',
            label: 'Goal Description',
            key: 'goalDescription'
          }
        ]
      },
      {
        title: 'Action Steps',
        fields: [
          {
            type: 'textarea',
            label: 'Action Step 1',
            key: 'actionStep1'
          },
          {
            type: 'textarea',
            label: 'Action Step 2',
            key: 'actionStep2'
          },
          {
            type: 'textarea',
            label: 'Action Step 3',
            key: 'actionStep3'
          },
          {
            type: 'textarea',
            label: 'Action Step 4',
            key: 'actionStep4'
          },
          {
            type: 'textarea',
            label: 'Action Step 5',
            key: 'actionStep5'
          }
        ]
      },
      {
        title: 'Status',
        fields: [
          {
            type: 'text',
            label: 'Current Status',
            key: 'status'
          }
        ]
      },
      {
        title: 'Notes/Updates',
        fields: [
          {
            type: 'textarea',
            label: 'Notes and Updates',
            key: 'notes'
          }
        ]
      }
    ]
  }
});

// Create a record of templates for all domains
export const TEMPLATES = CAPACITY_DOMAINS.reduce((acc, domain) => ({
  ...acc,
  [domain.id]: createTemplateForDomain(domain.id, domain.name)
}), {} as Record<string, ReturnType<typeof createTemplateForDomain>>);